import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getEquipmentAllotments } from 'app/entities/equipment-allotment/equipment-allotment.reducer';
import { getEntities as getEquipmentIPCharges } from 'app/entities/equipment-ip-charges/equipment-ip-charges.reducer';
import { getEntities as getHospitalPatientCategoryAttributes } from 'app/entities/hospital-patient-category-attributes/hospital-patient-category-attributes.reducer';
import { createEntity, getEntity, reset, updateEntity } from './equipment-allotment-charge.reducer';

export const EquipmentAllotmentChargeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const equipmentAllotments = useAppSelector(state => state.equipmentAllotment.entities);
  const equipmentIPCharges = useAppSelector(state => state.equipmentIPCharges.entities);
  const hospitalPatientCategoryAttributes = useAppSelector(state => state.hospitalPatientCategoryAttributes.entities);
  const equipmentAllotmentChargeEntity = useAppSelector(state => state.equipmentAllotmentCharge.entity);
  const loading = useAppSelector(state => state.equipmentAllotmentCharge.loading);
  const updating = useAppSelector(state => state.equipmentAllotmentCharge.updating);
  const updateSuccess = useAppSelector(state => state.equipmentAllotmentCharge.updateSuccess);

  const handleClose = () => {
    navigate(`/equipment-allotment-charge${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getEquipmentAllotments({}));
    dispatch(getEquipmentIPCharges({}));
    dispatch(getHospitalPatientCategoryAttributes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.fromDate !== undefined && typeof values.fromDate !== 'number') {
      values.fromDate = Number(values.fromDate);
    }
    if (values.toDate !== undefined && typeof values.toDate !== 'number') {
      values.toDate = Number(values.toDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }

    const entity = {
      ...equipmentAllotmentChargeEntity,
      ...values,
      allotment: equipmentAllotments.find(it => it.id.toString() === values.allotment?.toString()),
      appliedCharge: equipmentIPCharges.find(it => it.id.toString() === values.appliedCharge?.toString()),
      multiplierEntry: hospitalPatientCategoryAttributes.find(it => it.id.toString() === values.multiplierEntry?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...equipmentAllotmentChargeEntity,
          allotment: equipmentAllotmentChargeEntity?.allotment?.id,
          appliedCharge: equipmentAllotmentChargeEntity?.appliedCharge?.id,
          multiplierEntry: equipmentAllotmentChargeEntity?.multiplierEntry?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.equipmentAllotmentCharge.home.createOrEditLabel" data-cy="EquipmentAllotmentChargeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.home.createOrEditLabel">
              Create or edit a EquipmentAllotmentCharge
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="equipment-allotment-charge-id"
                  label={translate('tinyMedicRestApp.equipmentAllotmentCharge.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.fromDate')}
                id="equipment-allotment-charge-fromDate"
                name="fromDate"
                data-cy="fromDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.toDate')}
                id="equipment-allotment-charge-toDate"
                name="toDate"
                data-cy="toDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.active')}
                id="equipment-allotment-charge-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.cursor')}
                id="equipment-allotment-charge-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.lastUpdated')}
                id="equipment-allotment-charge-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.microSec')}
                id="equipment-allotment-charge-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.timestampEntry')}
                id="equipment-allotment-charge-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.quantity')}
                id="equipment-allotment-charge-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.discount')}
                id="equipment-allotment-charge-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                id="equipment-allotment-charge-allotment"
                name="allotment"
                data-cy="allotment"
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.allotment')}
                type="select"
              >
                <option value="" key="0" />
                {equipmentAllotments
                  ? equipmentAllotments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="equipment-allotment-charge-appliedCharge"
                name="appliedCharge"
                data-cy="appliedCharge"
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.appliedCharge')}
                type="select"
              >
                <option value="" key="0" />
                {equipmentIPCharges
                  ? equipmentIPCharges.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="equipment-allotment-charge-multiplierEntry"
                name="multiplierEntry"
                data-cy="multiplierEntry"
                label={translate('tinyMedicRestApp.equipmentAllotmentCharge.multiplierEntry')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalPatientCategoryAttributes
                  ? hospitalPatientCategoryAttributes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/equipment-allotment-charge" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EquipmentAllotmentChargeUpdate;
